import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import ProblemSolution from "../components/ProblemSolution";
import Features from "../components/Features";
import HowItWorks from "../components/HowItWorks";
import Audience from "../components/Audience";
import Directory from "../components/Directory";
import Resources from "../components/Resources";
import Pricing from "../components/Pricing";
import Testimonials from "../components/Testimonials";
import Faq from "../components/Faq";
import FinalCTA from "../components/FinalCTA";
import Footer from "../components/Footer";

export default function Home() {
    const location = useLocation();

    useLayoutEffect(() => {
        if (!location.hash) {
            return;
        }
        const id = location.hash.slice(1);
        if (!id) {
            return;
        }
        const el = document.getElementById(id);
        if (!el) {
            return;
        }
        const frame = requestAnimationFrame(() => {
            el.scrollIntoView({ behavior: "smooth", block: "start" });
        });
        return () => cancelAnimationFrame(frame);
    }, [location.pathname, location.hash]);

    return (
        <div className="bg-background text-foreground min-h-screen">
            <Navbar />
            <main data-testid="home-page">
                <Hero />
                <ProblemSolution />
                <Features />
                {/* <HowItWorks />
                <Audience /> */}
                {/* <Directory mode="teaser" /> */}
                {/* <Resources /> */}
                <Pricing />
                <Testimonials />
                <Faq />
                <FinalCTA />
            </main>
            <Footer />
        </div>
    );
}
